<template>
  <div>
    <base-crud
      crud-name="Departamentos"
      new-text="Novo Registro"
      :table="departmentsTable"
      :columns="columns"
      :options="options"
      :end-point="endPoint"
      :enable-add="true"
      :enable-edit="true"
      :enable-delete="true"
      :enable-view="false"
      :data-form="dataForm"
    />
  </div>
</template>

<script>
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      departmentsTable: 'departmentsTable',
      users: [],
      pages: [],
      url: '',
      columns: ['id', 'title', 'date', 'actions'],
      tableData: ['id', 'title', 'date'],
      options: {
        filterByColumn: true,
        filterable: ['id', 'title', 'date'],
        sortable: ['id', 'title', 'date'],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: 'ID',
          date: 'Data',
          title: 'Departamento',
          actions: 'Ações',
        },
        requestFunction(data) {
          const requestData = {}

          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = []

          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => {
              this.dispatch('error', e)
            },
          )
        },
        templates: {
          date(h, row, index) {
            if (row.fixed == '1') {
              return `${row.day}/${row.month}`
            }
            return moment(row.specific_date).format('DD/MM/YYYY')
          },
          responsible_id(h, row, index) {
            return row.responsible.name
          },
          miliseconds(h, row, index) {
            return msToTime(row.miliseconds)
          },
        },
      },
      endPoint: 'departments/',

      dataForm: {},
    }
  },
  methods: {
    query(query) {
      const columns = {
        id: 'id',
        title: 'title',
        date: 'date',
      }
      let filters = ''
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
